import axios, { reportClient } from "../../../AxiosClient";
import { generate } from "patternomaly";

const redirect = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? ":" + window.location.port : ""
}/oauth2/redirect`;

export const getChartData = (chartObject, callback, errorCallback) => {
  chartObject.authentication.authMethod === "OAuth"
    ? authGraphDomain(chartObject, callback, errorCallback)
    : getData(chartObject, callback, null, errorCallback);
};

export const getColours = (number, pattern, transparency) => {
  let palette = [
    "#1f77b4",
    "#e377c2",
    "#ff7f0e",
    "#2ca02c",
    "#bcbd22",
    "#d62728",
    "#17becf",
    "#9467bd",
    "#7f7f7f",
    "#8c564b",
    "#3366cc",
  ];
  if (transparency && transparency > 0) {
    palette = [
      `rgba(255, 99, 132, ${transparency})`,
      `rgba(255, 159, 64, ${transparency})`,
      `rgba(255, 205, 86, ${transparency})`,
      `rgba(75, 192, 192, ${transparency})`,
      `rgba(54, 162, 235, ${transparency})`,
      `rgba(153, 102, 255, ${transparency})`,
      `rgba(201, 203, 207, ${transparency})`,
    ];
  }
  let colours = [];

  for (let i = 0; i < number; i++) {
    colours.push(palette[i % palette.length]);
  }

  return pattern ? generate(colours) : colours;
};

const authGraphDomain = (chartObject, callback) => {
  let oAuthURL = chartObject.authentication.oAuthURL;
  if (!oAuthURL) return;
  oAuthURL =
    oAuthURL +
    "?" +
    chartObject.authentication.oAuthIdName +
    "=" +
    chartObject.authentication.oAuthId +
    "&" +
    chartObject.authentication.redirectParamName +
    "=" +
    redirect;
  chartObject.authentication.oAuthFilters.map(
    (filter) =>
      (oAuthURL = oAuthURL + "&" + filter.filterName + "=" + filter.filterValue)
  );
  openPopup(
    oAuthURL,
    (location) => {
      let url = new URL(location);
      let split = url.href.split("access_token=");
      split = split[1].split("&");
      let token = split[0];
      getData(chartObject, callback, token);
    },
    (message) => {
      console.log(message);
    }
  );
};
const openPopup = (
  url,
  successCallback,
  errCallback,
  redirectUrl = redirect
) => {
  let popUpWidth = 483;
  let popUpHeight = 600;
  let winLeft = window.screenLeft ? window.screenLeft : window.screenX;
  let winTop = window.screenTop ? window.screenTop : window.screenY;
  let width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  let height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  let left = width / 2 - popUpWidth / 2 + winLeft;
  let top_1 = height / 2 - popUpHeight / 2 + winTop;
  let popup = window.open(
    url,
    "",
    "width=" +
      popUpWidth +
      ", height=" +
      popUpHeight +
      ", top=" +
      top_1 +
      ", left=" +
      left
  );
  var pollTimer = window.setInterval(() => {
    if (popup && popup.closed) {
      window.clearInterval(pollTimer);
      errCallback();
    } else {
      try {
        var popUpWindowLocation = popup.location;
        if (popUpWindowLocation.href.indexOf(redirectUrl) !== -1) {
          window.clearInterval(pollTimer);
          popup.close();
          successCallback(popUpWindowLocation);
        }
      } catch (e) {
        // we will catch a cross origin error every time we try to access the popup until it redirects, ignore it
      }
    }
  }, 1);
};
const getData = (chartObject, callback, token, errorCallback) => {
  if (chartObject.authentication.radioChoice === "External") {
    let config = {
      // headers: { "Access-Control-Allow-Origin": "*" },
    };
    let parameters = "?";
    if (chartObject.authentication.authMethod === "OAuth") {
      config = {
        ...config,
        // headers: { Authorization: `Bearer ${token}` },
      };
      if (chartObject.authentication.requestTokenMethod === "Parameters") {
        parameters = `${parameters}access_token=${token}&`;
      }
    }
    if (chartObject.authentication.authMethod === "ApiKey") {
      if (chartObject.authentication.apiKeyMethod === "Parameter") {
        parameters = `${parameters}${
          chartObject.authentication.apiKeyParamName
        }=${chartObject.authentication.apiKeyValue}&`;
      }
    }
    let body = {};
    if (chartObject.authentication.radioDataSendMethodChange === "Parameters") {
      chartObject.chart.dataFilters.map(
        (filter) =>
          (parameters =
            parameters + filter.filterName + "=" + filter.filterValue + "&")
      );
    } else {
      chartObject.chart.dataFilters.map(
        (filter) => (body[filter.filterName] = filter.filterValue)
      );
    }
    axios
      .get(chartObject.chart.dataUrl + parameters, body, config)
      .then((res) => {
        getSeriesData(chartObject, callback, res.data);
      });
  } else if (chartObject.authentication.radioChoice === "Internal") {
    reportClient({
      url: "/graphql",
      method: "post",
      data: chartObject.chart.query,
    }).then((res) => {
      if (
        res.data.data === null ||
        (res.data.errors && res.data.errors.length > 0)
      ) {
        let error = "GraphQL Error";
        if (res.data.errors.length > 0) {
          error = res.data.errors[0].message;
        }
        if (errorCallback) {
          errorCallback(error);
        } else {
          console.error(error);
        }
      } else {
        let keyName = Object.keys(res.data.data)[0];
        getSeriesData(chartObject, callback, res.data.data[keyName]);
      }
    });
    return;
  }
};

const getSeriesData = (chartObject, callback, data) => {
  let array = data;
  if (Array.isArray(data)) {
    return callback(data);
  }
  chartObject.chart.dataBreadcrumbs.map((header) => {
    array = array[header.value];
  });
  callback(array);
};
